/**
 * Snapshot Whats New Modal
 */
const WhatsNewModal = {
	/**
	 * Initialize the modal
	 */
	init() {
		this.whats_new_modal = document.querySelector( '#snapshot-whats-new-modal' );
		if ( this.whats_new_modal && ! document.querySelector( '#snapshot-welcome-dialog' ) ) {
			this.open();
			this.listeners();
		}
	},

	/**
	 * Register event listeners.
	 */
	listeners() {
		const _self = this;
		this.whats_new_modal.addEventListener( 'click', ( e ) => {
			const el = e.target;
			if ( el.classList.contains( 'snapshot-whats-new-modal--close' ) ||
				el.closest( 'button' ).classList.contains( 'snapshot-whats-new-modal--close' )
			) {
				_self.close();
			}
		} );
	},

	/**
	 * Opens the whats new modal.
	 */
	open() {
		if ( document.querySelector( '#snapshot-membership-expired-modal' ) ) {
			// Don't show the Whats New modal if the membership expired modal is present.
			return;
		}

		if ( this.whats_new_modal ) {
			window.SUI.openModal( 'snapshot-whats-new-modal', window );
		}
	},

	/**
	 * Closes the Whats New modal.
	 * Also sends a request to the server to mark the modal as seen.
	 */
	close() {
		const formData = new FormData();
		formData.append( 'action', 'snapshot-whats_new_seen' );
		formData.append( '_wpnonce', document.querySelector( '#_wpnonce-whats_new_seen' ).value );

		// eslint-disable-next-line no-undef
		const req = fetch( SnapshotAjax.ajaxurl, {
			method: 'POST',
			credentials: 'same-origin',
			body: formData,
		} );

		req.then( ( response ) => response.json() )
			.then( ( result ) => {
				if ( result.success !== true ) {
					window.console.error( result );
				}
			} );
	}
};

export default WhatsNewModal;
